const FOOTER_ACCORDION_BREAKPOINT = 767;

function createAccordionButton(title, controlsId) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "bn-footer__accordion-toggle";
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-controls", controlsId);
    button.innerHTML = `<span>${title}</span>`;

    return button;
}

function getAccordionColumns() {
    return Array.from(document.querySelectorAll(".bn-footer .bn-column")).filter((column) => {
        return column.querySelector(".bn-text h3") && column.querySelector(".bn-list");
    });
}

function setDesktopState(column) {
    const heading = column.querySelector(".bn-text h3");
    const panel = column.querySelector(".bn-footer__accordion-panel");
    const button = column.querySelector(".bn-footer__accordion-toggle");

    if (heading) {
        heading.hidden = false;
    }

    if (panel) {
        panel.hidden = false;
        panel.setAttribute("aria-hidden", "false");
    }

    if (button) {
        button.hidden = true;
        button.setAttribute("aria-expanded", "true");
    }

    column.classList.remove("--accordion-open");
}

function setColumnOpenState(column, isOpen) {
    const panel = column.querySelector(".bn-footer__accordion-panel");
    const button = column.querySelector(".bn-footer__accordion-toggle");

    column.classList.toggle("--accordion-open", isOpen);

    if (button) {
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }

    if (panel) {
        panel.hidden = false;
        panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    }
}

function setMobileState(column) {
    const heading = column.querySelector(".bn-text h3");
    const panel = column.querySelector(".bn-footer__accordion-panel");
    const button = column.querySelector(".bn-footer__accordion-toggle");

    if (!heading || !panel || !button) {
        return;
    }

    const isOpen = column.classList.contains("--accordion-open");

    heading.hidden = true;
    button.hidden = false;
    button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    panel.hidden = false;
    panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
}

function setupColumn(column, index) {
    if (column.dataset.footerAccordionReady === "true") {
        return;
    }

    const heading = column.querySelector(".bn-text h3");

    if (!heading) {
        return;
    }

    const title = heading.textContent.trim();
    const controlsId = `bn-footer-accordion-panel-${index + 1}`;
    const wrapper = heading.closest(".bn-text");
    const panel = document.createElement("div");

    panel.className = "bn-footer__accordion-panel";
    panel.id = controlsId;
    panel.setAttribute("aria-hidden", "true");

    while (wrapper && wrapper.nextSibling) {
        panel.appendChild(wrapper.nextSibling);
    }

    column.appendChild(panel);

    const button = createAccordionButton(title, controlsId);

    button.addEventListener("click", () => {
        const willOpen = !column.classList.contains("--accordion-open");

        getAccordionColumns().forEach((accordionColumn) => {
            if (accordionColumn !== column) {
                setColumnOpenState(accordionColumn, false);
            }
        });

        setColumnOpenState(column, willOpen);
    });

    wrapper.insertAdjacentElement("afterend", button);
    column.dataset.footerAccordionReady = "true";
}

export function footerAccordion() {
    const columns = getAccordionColumns();

    if (!columns.length) {
        return;
    }

    columns.forEach(setupColumn);

    const syncMode = () => {
        const isMobile = window.innerWidth <= FOOTER_ACCORDION_BREAKPOINT;

        columns.forEach((column) => {
            if (isMobile) {
                setMobileState(column);
                return;
            }

            setDesktopState(column);
        });
    };

    syncMode();

    if (document.body.dataset.footerAccordionBound === "true") {
        return;
    }

    window.addEventListener("resize", syncMode);
    document.body.dataset.footerAccordionBound = "true";
}